import { intl } from '@beelday/common'
import { useSelector } from 'app-redux'
import { ArchivedActivityCard } from 'features/script'
import { ComponentProps } from 'react'
import { navigateToRecaps } from 'workflow/navigate-to-recaps'
import { ArchivedActivityView } from './presentation/archived-activity-view'

type Props = {
	toolType: ComponentProps<typeof ArchivedActivityCard>['toolType']
	title: string
}

export const ConfiguredArchivedActivity = ({
	toolType,
	title,
}: Props): JSX.Element => {
	const training = useSelector(state => state.sessionInfo.training)
	const translate = intl.useTranslate()

	return (
		<ArchivedActivityView
			toolName={translate(`training.script.tool.${toolType}.title`)}
			title={title}
			onSeeInRecaps={
				training
					? () =>
							navigateToRecaps({ trainingId: training.id, isTrainer: false })
					: undefined
			}
		/>
	)
}

export default ConfiguredArchivedActivity
